/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Box } from "@mui/material";
import VitalsDataContent from "components/content/VitalsDataContent";
import HeaderPersonInformation from "components/views/HeaderPersonInformation";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { AppointmentInterface, HeaderEnum } from "@malmur-technologies/medicalsystem-shared";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Patient vital signs recording and tracking page.
 * 
 * Features:
 * - Vital signs data entry (BP, HR, temp, weight, height, O2 sat, etc.)
 * - Historical vital signs tracking with trend charts
 * - Appointment-specific vital signs recording
 * - Patient demographic header display
 * - Integration with office visit workflow
 * - Automatic BMI calculation
 * - Vital signs alerts for abnormal values
 * 
 * The page receives appointment ID via navigation state and loads
 * the associated appointment and patient data for context.
 * 
 * @returns Vitals recording page component
 */
const VitalsPage = () => {
  const location = useLocation();
  const state = (location.state as { data?: string; savedEntityId?: string }) || {};
  const appointmentId = state.data || state.savedEntityId || null;
  const [appointmentModel, setAppointmentModel] = useState<AppointmentInterface>();
  const [_isLoading, _error, sendRequest] = useHttp();

  useEffect(() => {
    if (appointmentId) {
      sendRequest(
        CoreAPI_URLs.APPOINTMENTS_GENERAL_OPERATIONS,
        onGetAppointment,
        "GET",
        undefined,
        [
          {
            header: HeaderEnum.RESOURCE_ID,
            value: appointmentId,
          },
        ]
      );
    }
  }, [appointmentId]);

  /**
   * Callback handler for appointment data retrieval.
   * Updates appointment state for display in vitals context.
   * 
   * @param {AppointmentInterface} data - Retrieved appointment data
   * @returns {void}
   */
  const onGetAppointment = (appointment: AppointmentInterface) => {
    setAppointmentModel(appointment);
  };
  return (
    <DefaultDashboardLayout>
      <Box>
        {appointmentModel && (
          <HeaderPersonInformation personInformation={appointmentModel.patient.person} showPhoto/>
        )}
        {appointmentModel && <VitalsDataContent selectedAppointment={appointmentModel} />}
      </Box>
    </DefaultDashboardLayout>
  );
};

export default VitalsPage;

